import React from "react";
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
`;

const TitleSears = styled.p`
    font-size: 26px;
    margin:    7% 0em 0% 2%;
    padding:   0em 0em 0em 0em;
    font-family:  "Amx-Regular";
    color: #1e1e1e;
    text-align:  left;
    font-weight:  regular;
    font-style: normal;
`;

const SubtitleSears = styled.p`
    font-size: 14px;
    margin:  3% 0% 16px 2%;
    padding:  0em 0em 0em 0em;
    font-family: "Amx-Regular";
    color: #626262;
    text-align:  left;
    font-weight: regular;
    font-style:  normal;
`;

const DisclaimerMessageContainer = styled.div`
    align-items: center;
    background: rgba(241, 241, 241, 0.5);
    color: #0e0e0e;
    display: flex;
    font-family:  "Amx-Regular";
    font-size: 15px;
    margin:  0px 2% 24px 2%;
    padding: 8px;
    line-height: 22px;
    border-radius: 4px;
`;

const DisclaimerMessageContainerImg = styled.img`
    width: 32px;
    height: 32px;
    margin-right: 16px;
`;

const DisclaimerMessageContainerText = styled.p`
    margin: 0px;
`;

const InputContainer = styled.div`
    border: ${props => props.valid ? '1px solid #c4c4c4' : '1px solid #d92c27'};
    margin: 3% 3% 0% 3%;
    border-radius : 5px;
    background: #fff;
    &:hover {
        ${props => props.valid ? '1px solid black' : '1px solid #d92c27'};
    }
`;

const InputField = styled.input`
display: inline;
margin: ${props => props.margin ? props.margin : '0rem'};
padding: ${props => props.padding ? props.padding : '0% 0% 0% 3%;'};
height: ${props => props.height ? props.height : 'auto'};
min-height: ${props => props.height ? props.height : '40px'};
font-family: ${props => props.fontFamily ? props.fontFamily : "Amx-Regular"};
font-weight: ${props => props.fontWeight ? props.fontWeight : 'meddium'};
color: ${props => props.valid ? '#323232' : '#d92c27'};
font-size: ${props => props.fontSize ? props.fontSize : '16px'};
line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
border-top-left-radius: 5px;
border-bottom-left-radius: 5px;
border: none;
background: ${props => props.background ? props.background : 'transparent'};
width: ${props => props.width ? props.width : '85%'};
text-align: ${props => props.textAlign ? props.textAlign : 'left'};
flex-grow: ${props => props.flexGrow ? props.flexGrow : '1'};
max-width: 100%;
::placeholder {
    margin: 0% 0% 0% 0%;
    padding:  0% 0% 0% 1%;
    color: #c4c4c4;
    font-size: ${props => props.fontSize ? props.fontSize : '0.7rem'};
    line-height: ${props => props.lineHeight ? props.lineHeight : 'auto'};
    vertical-align: ${props => props.verticalAlign ? props.verticalAlign : 'middle'};
    font-family: ${props => props.fontFamily ? props.fontFamily : "Amx-Regular"};
    text-align: ${props => props.textAlign ? props.textAlign : 'left'};
    font-weight: ${props => props.fontWeight ? props.fontWeight : ''};
},
`

const Button = styled.button`
    border: 1px solid black;
    border-radius: 25px;
    font-size: 14px;
    background: black;
    color: white;
    text-align: center;
    padding:0px 0px;
    margin: 15% auto 0px auto;
    font-weight: meddium;
    font-family:"AMX-Regular";
    width: 50%;
    height : 45px;
    line-height: 37px;
    outline: none;
    &:disabled {
        color: #000;
        background: #fff; 
        border: 1px solid #c4c4c4;
        outline: none;
    }
`;

const Label = styled.label`
    margin: 0% 0% 0% 3%;
    font-family: "Amx-Regular";
    color: #000;
    text-align:  left;
    font-weight: regular;
    font-size: 14px;
`;

const LabelError = styled.label`
    margin: 0% 0% 0% 3%;
    font-family: "Amx-Regular";
    color: #d92c27;
    text-align:  left;
    font-weight: regular;
    font-size: 12px;
`;


const SearsHome = ({
    titleSears, 
    subtitleSears, 
    valueInput, 
    handleOnchangeInput, 
    disableButton, 
    handleClickTooltip,
    handleClickButton,
    validForm,
    disclaimer
}) => {
    let srcImage = (disableButton)?"./images/path_continuar.svg": "./images/path_continuar_blanca.svg"
    return(
        <Container>
            <TitleSears >
                {titleSears}
            </TitleSears>
            <SubtitleSears >
                {subtitleSears}
            </SubtitleSears>
            <DisclaimerMessageContainer>
                <DisclaimerMessageContainerImg 
                    src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAMAAACdt4HsAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABRUExURUdwTDBOW9rf4TBBW8rR1DBOWjBMWKy5vq65vrS5ubC8wa24vq+8wjBPWTBNWDBOW4aXnzBNWtjd3zBOWzxYY9vb39re4DBMXNrf4DBOW9re4Oc8Tv8AAAAZdFJOUwDrfxCegEBmWg1ROCMwIM/9ZmO5mzrXUL+B/yAWAAABV0lEQVRYw+2X3ZKDIAyFQcWIoJZquxve/0HXn3ZUKhbIxe5MN5c65yMkJ3Fk7AMiz2l6w1GQABwRWwpg1GP5D3AApWhIABGZUo/Ic0cf5Yx26BtXjya5Iote/Jr+K0J/u/kSCNPfrc1enzbh51t7SGhFoAOk9RCC4/oHCBmRIKFYCKLnnYnfq7KCB+Ey9Z5Hb8UaYEfoI/UKwCFs+5+Xc5xkpQFcwmaAW454PhRTAVyC2a2YR/hqu+pXwuYKwzuAAnglbAeiW+TchOifhCzCQUAiyApohBqARFAAJIIGIBGOCrAjXN8A/HrQ84a5p+orveyoIr4Bc9Ryfv9d6LTzVZCB/OfrdAPN15eMYKDA9E8S0KEz6Kl+sP64BbWMXsNJ1/dMwaDjP0Xb4NjlFEI17n4KoZINiTC5j0JY3JtOeLY/hcC0Umv7JsJA+uEaCTQAaw3xp/Ez4gcR7i3d1YzAFQAAAABJRU5ErkJggg=="
                />
                <DisclaimerMessageContainerText>
                    <span dangerouslySetInnerHTML={{__html: disclaimer}}></span>
                </DisclaimerMessageContainerText>
            </DisclaimerMessageContainer>
            <Label>Número de tu tarjeta:</Label>
            <InputContainer valid = {validForm}>
                <InputField 
                    value={valueInput} 
                    onChange={(e) =>{handleOnchangeInput(e)}}
                    name={"card_number"}
                    placeholder={"Ingresa los dígitos de tu tarjeta "}
                    id = {"card_number"}
                    valid = {validForm}
                    type = "number"
                />
                <span onClick={handleClickTooltip}>
                    <img src={"./images/signoDeInterrogaciN.svg"}  style={{verticalAlign:"middle"}}/>
                </span>
            </InputContainer>
            {
                (!validForm)?<LabelError>Ingresa los números de tu tarjeta</LabelError>: <></>
            }
            <div style={{textAlign:"center"}}>
                <Button  disabled={disableButton} onClick={(e) => {handleClickButton(valueInput)}}>
                    {"Continuar "}  
                    <img src={srcImage} style={{margin:"0px 0px 2px 5px", verticalAlign: "middle"}}/>
                </Button>
            </div>
        </Container> 
    )
}

export default SearsHome;